import { render, staticRenderFns } from "./ViewEditClinicUploadedImages.vue?vue&type=template&id=2b9e66ec&scoped=true&"
import script from "./ViewEditClinicUploadedImages.vue?vue&type=script&lang=js&"
export * from "./ViewEditClinicUploadedImages.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditClinicUploadedImages.vue?vue&type=style&index=0&id=2b9e66ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e66ec",
  null
  
)

export default component.exports